export const DataClassificationTooltip = () => (
  <>
    Information Classification according to Bayer standards, see more at{" "}
    <a href="https://go.cnb/ICL" target="_blank">
      go/ICL
    </a>
  </>
);
